import React from "react";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Moment } from "moment";

interface IMonthPickerProps {
    onDateChange: (newValue: Moment) => void
    value: Moment
}

export default function MonthPicker({ onDateChange, value }: IMonthPickerProps) {
    return (
        <>
            <DateCalendar
                value={ value}
                views={['month', 'year']}
                disableFuture
                onChange={(newValue: moment.Moment) => onDateChange(newValue)} />
        </>
    );
};
